import { CardShared } from '@/app/components/card/shared';
import { SPECIAL_OFFER_EVENT_NAME } from '@/app/components/sections/special-offer/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { SpecialOffer } from '@/types/special-offer';

const BASE_URL = '/specialoffer';

export interface OffersGridProps {
  entries: SpecialOffer[];
  currentCategory?: string;
}

export const OffersGrid = ({ entries, currentCategory }: OffersGridProps) => {
  if (entries.length === 0) {
    return (
      <div
        className="flex flex-col items-center justify-center py-24 text-center text-gray-500 md:py-28"
        {...createDataAttributes({ test: 'empty-state' })}
      >
        <p>ขออภัย ยังไม่มีข้อเสนอพิเศษประเภทนี้</p>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:gap-8"
      {...createDataAttributes({ test: 'offers-grid' })}
    >
      {entries.map((offer, index) => {
        const categoryData = offer.category?.[0];
        const href = `${BASE_URL}/${categoryData?.url}/${offer.url}`;
        const categoryUrl = `${BASE_URL}/${categoryData?.url}`;

        return (
          <CardShared
            key={offer.uid}
            href={href}
            title={offer.name ?? ''}
            image={{
              priority: index <= 1,
              rootMargin: '10% 0px 0px 0px',
              loadedEffect: 'fade',
              placeholder: 'shimmer',
              src: offer.img?.url ?? '',
              alt: offer.name ?? '',
              width: 312,
              height: 176,
              aspectRatio: 'aspect-16-9',
              sizes: '(min-width: 1280px) 572px, (min-width: 768px) 46vw, 90vw',
              srcSetOptions: {
                crop: '16:9',
              },
            }}
            date={{
              startDate: offer.begin_date ?? '',
              endDate: offer.end_date ?? '',
            }}
            untilText
            dataGA={{
              eventName: SPECIAL_OFFER_EVENT_NAME,
              click: true,
              text: offer.name ?? '',
              value: index,
              url: href,
            }}
            {...(categoryData &&
              !currentCategory && {
                tag: {
                  label: categoryData.name ?? '',
                  href: categoryUrl,
                },
              })}
            {...createDataAttributes({ test: `offer-card-${index}` })}
          />
        );
      })}
    </div>
  );
};
